
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const Overhead360Page = lazy(() => import('../pages/overhead-360/page'));
const PhotoBoothPage = lazy(() => import('../pages/photo-booth/page'));
const CustomTemplatesPage = lazy(() => import('../pages/custom-templates/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/overhead-360',
    element: <Overhead360Page />,
  },
  {
    path: '/photo-booth',
    element: <PhotoBoothPage />,
  },
  {
    path: '/custom-templates',
    element: <CustomTemplatesPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
